module.exports = __webpack_public_path__ + "Icon_Bricks.1aeb864b373f658357bc.png";